import { ContentTypes } from "../brandVariables.types";

export const samsungContent: ContentTypes = {
  generalHeadline: "Samsung Racing",
  generalHeadlineAlt: "Set the fastest lap!",
  subHeadline: "Lorem ipsum...",
  overviewHeadline: "winners overview!",
  endscreenHeadline: "Thank you and congratulations to our winners",
};
